import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  connect() {
    this.strip();
  }

  strip() {
    const input = this.element;
    const oldValue = input.value;
    const newValue = oldValue.replace(/\D/g, "");

    if (newValue === oldValue) return;

    const cursor = input.selectionStart ?? newValue.length;
    const digitsBeforeCursor = oldValue.slice(0, cursor).replace(/\D/g, "").length;

    input.value = newValue;

    if (input.setSelectionRange) {
      input.setSelectionRange(digitsBeforeCursor, digitsBeforeCursor);
    }
  }
}
